(() => {
  const cards = 'product-card, [data-vanity-color-card], .product-grid__item, .resource-card__wrapper';
  const pointerMode = () => { document.documentElement.dataset.vanityCardKeyboard = 'false'; };
  const clearRestoredFocus = () => {
    pointerMode();
    const active = document.activeElement;
    if (active instanceof HTMLElement && active.closest(cards)) active.blur();
  };
  document.addEventListener('keydown', event => {
    if (event.key === 'Tab' || event.key.startsWith('Arrow')) document.documentElement.dataset.vanityCardKeyboard = 'true';
  }, true);
  document.addEventListener('pointerdown', pointerMode, true);
  document.addEventListener('touchstart', pointerMode, {capture: true, passive: true});
  window.addEventListener('pageshow', () => {
    clearRestoredFocus();
    requestAnimationFrame(() => requestAnimationFrame(clearRestoredFocus));
  });
  pointerMode();
})();
